import { render, staticRenderFns } from "./createEvent.vue?vue&type=template&id=d218f212&scoped=true"
import script from "./createEvent.vue?vue&type=script&lang=js"
export * from "./createEvent.vue?vue&type=script&lang=js"
import style0 from "./createEvent.vue?vue&type=style&index=0&id=d218f212&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d218f212",
  null
  
)

export default component.exports